import { render, staticRenderFns } from "./changeContractDetail.vue?vue&type=template&id=477f5c68&scoped=true&"
import script from "./changeContractDetail.vue?vue&type=script&lang=js&"
export * from "./changeContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./changeContractDetail.vue?vue&type=style&index=0&id=477f5c68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f5c68",
  null
  
)

export default component.exports